<template>
    <div class="api-img" :id="currentID"  :class="{'rowed': rowed}" @click="showModal()">

        <b-img thumbnail :src="computedUri" :alt="alt" />

        <div class="widget" style="display: none;">
            <div class="md-dialog">
                <img style="max-width: 60vw;" :src="computedUri" />
            </div>
        </div>

    </div>
</template>

<script>
    import mobiscroll from '@mobiscroll/javascript'
    import _ from 'lodash'
    import noPicture from '@/assets/images/no-picture.png'
    import axios from 'axios'
    export default {
        props: ['comp', 'alt', 'rowed'],
        data: () => {return {
            currentID: null
        }},
        beforeMount(){
            this.currentID = _.uniqueId('api-img-');
        },
        computed: {
            computedUri(){
                if (this.comp != null  && this.comp != '' && typeof parseInt(this.comp) == 'number'){
                    return axios.defaults.maediaImageRender + this.comp  + "/b-imgs.jpg"
                }  else {
                    return noPicture
                }
            }
        },
        methods: {
            showModal(){
                let m = mobiscroll.widget('#' + this.currentID + ' .widget', {
                    display: 'center',
                    // theme: 'ios-dark',
                    // display: 'bubble',
                    // anchor: '#' + this.currentID,
                    animate: 'pop',
                    closeOnOverlayTap: true,
                    buttons: [
                        { 
                            text: ' Cerrar',
                            handler: 'cancel',
                            // icon: 'close'
                        }
                    ]
                })
                m.show()
            }
        }
    }
</script>

<style lang="less">
    .api-img {
        display: inline-block;
        text-align: center;
        height: 10em; width: 100%;

        IMG {
            border: 1px solid #ddd;
            display: inline;
            object-fit: contain;
            border-radius: 0.5em;
            height: 100%; width: 100%;
        }

        &.rowed IMG {
            width: 2.5em;
            height: 2.5em;
            padding: 0em; margin: 0;
        }
        

        .widget {
            IMG {
                max-width: 60vw;
            }
        }

    }
</style>


